import { utilConstants } from './types';
import { Auth, API } from 'aws-amplify';

export const utilsActions = {
    getChannels,
    getStores,
};

function getChannels() {
    return (dispatch) => {
        dispatch(request());

        Auth.currentSession().then((currentSession) => {
            API.get('admin', `/utils?retrieve=channels`, {})
                .then((response) => dispatch(success(response.data)))
                .catch((error) => dispatch(failure(error.error)));
        });
    };

    function request() {
        return { type: utilConstants.GET_CHANNELS_REQUEST };
    }
    function success(channels) {
        return { type: utilConstants.GET_CHANNELS_SUCCESS, channels };
    }
    function failure(error) {
        return { type: utilConstants.GET_CHANNELS_FAIL, error };
    }
}

function getStores() {
    return (dispatch) => {
        dispatch(request());

        Auth.currentSession().then((currentSession) => {
            API.get('admin', `/utils?retrieve=stores`, {})
                .then((response) => dispatch(success(response.data)))
                .catch((error) => dispatch(failure(error.error)));
        });
    };

    function request() {
        return { type: utilConstants.GET_STORES_REQUEST };
    }
    function success(stores) {
        return { type: utilConstants.GET_STORES_SUCCESS, stores };
    }
    function failure(error) {
        return { type: utilConstants.GET_STORES_FAIL, error };
    }
}
